export default "__VITE_ASSET__DXbteobi__"